<template>
  <section v-if="!getDeviceType()">
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="isEditingInterest"
    >
      <div class="interestBox">
        <AddInterests
          :selectedInterests="newInterests"
          :isProfile="false"
          :maxInterests="5"
        />
      </div>
    </div>
    <div class="loginPage">
      <div class="loginColumn">
        <img class="loginLogo" src="@/assets/searchLogo.svg" />
        <img class="loginImage" src="@/assets/loginIcon.png" />
        <img class="loginLogoText" src="@/assets/CourseLnk.png" />
      </div>
      <div class="loginColumn">
        <div v-if="loggedIn" class="loginForm setUpForm">
          <p class="loginTitle">Set up your account</p>
          <div class="loginTitleUnderline"></div>
          <SliderFrame class="">
            <div
              class="setUpBox"
              slot-scope="{ next, prev, activeIndex, goToIndex }"
            >
              <!--prev-->
              <SliderSlides>
                <SliderSlide class="o-vertical-spacing">
                  <form
                    class="smallForm"
                    @submit.prevent="addReferallCode(activeIndex, goToIndex)"
                  >
                    <div>
                      <p class="loginHeaderText">Referral Code</p>
                      <p>
                        Did someone refer you? Thank them by entering their
                        referral code! That way you can both become eligible for
                        a raffle.
                      </p>
                      <div class="user-input-wrp">
                        <input
                          v-model="referralCode"
                          type="text"
                          name="referralCode"
                          required
                          placeholder=" "
                          class="inputText"
                        />
                        <span class="floating-label">Referral Code</span>
                      </div>
                      <p>{{ referralFeedback }}</p>
                    </div>
                    <div>
                      <div class="App__basic-example-controls setUpButtons">
                        <button class="joinButtonSmallSkip" @click="next">
                          Skip
                        </button>
                        <button
                          class="joinButtonSmall smallWidth"
                          type="submit"
                        >
                          Next
                        </button>
                      </div>
                      <div class="hiddenButton"></div>
                    </div>
                  </form>
                </SliderSlide>
                <SliderSlide class="o-vertical-spacing">
                  <form
                    class="smallForm"
                    @submit.prevent="addYearAndMajor(activeIndex, goToIndex)"
                  >
                    <div>
                      <p class="loginHeaderText">Year and Major</p>
                      <p>Your profile helps you meet other students like you</p>
                      <div class="user-input-wrp">
                        <input
                          v-model="Year"
                          placeholder=" "
                          required
                          list="yearSelect"
                          class="inputText"
                          name="Year"
                        />
                        <datalist id="yearSelect">
                          <option value="1st Year"></option>
                          <option value="2nd Year"></option>
                          <option value="3rd Year"></option>
                          <option value="4th Year"></option>
                          <option value="5th Year"></option>
                          <option value="Grad"></option>
                          <option value="PhD"></option>
                        </datalist>
                        <span class="floating-label">Year</span>
                      </div>
                      <div class="user-input-wrp">
                        <input
                          v-model="Major"
                          type="text"
                          name="Major"
                          required
                          placeholder=" "
                          class="inputText"
                        />
                        <span class="floating-label">Major</span>
                      </div>
                      <p>{{ yearMajorFeedback }}</p>
                    </div>
                    <div>
                      <div class="App__basic-example-controls setUpButtons">
                        <button
                          class="joinButtonSmall smallWidth"
                          type="submit"
                        >
                          Next
                        </button>
                        <!--button class="joinButtonSmallSkip" @click="next">
                          Skip
                        </button-->
                      </div>
                      <button
                        v-if="!alreadyEntered"
                        class="previousButton"
                        @click="prev"
                      >
                        &laquo; Back
                      </button>
                    </div>
                  </form>
                </SliderSlide>
                <SliderSlide class="o-vertical-spacing">
                  <div class="smallForm">
                    <div>
                      <p class="loginHeaderText">Profile Image</p>
                      <p>Adding a photo helps students recognize you</p>
                      <div class="profileImageLogin">
                        <img
                          v-if="!profileImage"
                          class="accountSetUpPic"
                          src="@/assets/addImageSetup.svg"
                          alt="profile Image"
                        />
                        <img
                          v-else
                          class="accountSetUpPic"
                          :src="profileImage"
                          alt="profile Image"
                        />
                        <vue-dropzone
                          ref="imgDropZone"
                          id="profile-picLogin"
                          :include-styling="false"
                          :options="dropzoneOptions"
                          @vdropzone-complete="setImage"
                        ></vue-dropzone>
                      </div>
                      <p>{{ photoFeedback }}</p>
                    </div>
                    <div>
                      <div class="App__basic-example-controls setUpButtons">
                        <button class="joinButtonSmallSkip" @click="next">
                          Skip
                        </button>
                        <button
                          class="joinButtonSmall smallWidth"
                          @click="addImage(activeIndex, goToIndex)"
                        >
                          Next
                        </button>
                      </div>
                      <button class="previousButton" @click="prev">
                        &laquo; Back
                      </button>
                    </div>
                  </div>
                </SliderSlide>
                <SliderSlide class="o-vertical-spacing">
                  <div class="smallForm">
                    <div>
                      <p class="loginHeaderText">Interests</p>
                      <p>
                        Interests can help you meet people like you and join
                        groups that you like
                      </p>
                      <div class="setupInterestBox">
                        <div id="interestList">
                          <div
                            v-for="(interest, index) in newInterests"
                            :key="index"
                          >
                            <Interest
                              :icon="interest.unicode"
                              :interest="interest.name"
                            />
                          </div>
                        </div>
                        <div class="setInterestBox" @click="addInterests">
                          Set interest
                        </div>
                      </div>
                      <p>{{ interestFeedback }}</p>
                    </div>
                    <div>
                      <div class="App__basic-example-controls setUpButtons">
                        <button class="joinButtonSmallSkip" @click="next">
                          Skip
                        </button>
                        <button
                          class="joinButtonSmall smallWidth"
                          @click="setInterests(activeIndex, goToIndex)"
                        >
                          Next
                        </button>
                      </div>
                      <button class="previousButton" @click="prev">
                        &laquo; Back
                      </button>
                    </div>
                  </div>
                </SliderSlide>
                <SliderSlide class="o-vertical-spacing smallForm">
                  <div>
                    <p class="loginHeaderText">
                      Congratulations! you're all set up!
                    </p>
                    <p>
                      Just log in and you can start your new campus life now
                    </p>
                  </div>
                  <div>
                    <div class="setUpLoginRouterBox">
                      <div class="setUpLoginButtonOnSetUp" @click="goToProfile">
                        Continue
                      </div>
                    </div>
                    <div class="App__basic-example-controls setUpButtons"></div>
                    <button class="previousButton" @click="prev">
                      &laquo; Back
                    </button>
                  </div>
                </SliderSlide>
              </SliderSlides>
            </div>
          </SliderFrame>
        </div>
        <div v-else class="loginForm setUpForm">
          <p class="loginTitle">Verified email</p>
          <div class="loginTitleUnderline"></div>
          <div class="centerImage">
            <img
              class="sentEmailIcons"
              src="@/assets/verificationEmailIcon.png"
            />
          </div>
          <p class="setupMarginBottomText">
            Please continue the signup process on the device you started on
          </p>
          <!--router-link
            class="smallWidth setupButtonMargins"
            :to="{ name: 'Login' }"
            >Back to login</router-link
          -->
        </div>
      </div>
      <div class="bottomNav">
        <p class="landingButtonHoverless">CourseLnk © 2021</p>
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomNavSmall">
        <p class="landingButtonHoverless">CourseLnk © 2021</p>
        <div class="bottomColumn">
          <router-link
            class="landingButton"
            :to="{
              name: 'Landingpage',
            }"
            >About</router-link
          >
          <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
            Join the team
          </router-link>
        </div>
        <div class="bottomColumn">
          <router-link
            class="landingButton"
            :to="{ name: 'Terms' }"
            target="_blank"
          >
            Terms and Conditions
          </router-link>
          <router-link
            class="landingButton"
            :to="{ name: 'Privacy' }"
            target="_blank"
          >
            Privacy Policy
          </router-link>
        </div>
      </div>
    </div>
  </section>
  <div v-else class="loginPage">
    <div class="loginColumn"></div>
    <div class="loginColumn">
      <div @submit.prevent="login" class="loginForm formOnPhone">
        <img class="loginLogo" src="@/assets/searchLogo.svg" />
        <img class="loginLogoTextPhone" src="@/assets/CourseLnk.png" />
        <p class="loginTitle">Welcome to your online campus!</p>
        <form
          method="get"
          action="https://apps.apple.com/ca/app/courselnk/id1545799969"
        >
          <img src="../../assets/downloadOnAppStore.png" />
        </form>
        <p class="phoneText">Or access courselnk.com on a computer</p>
      </div>
    </div>
  </div>
</template>

<script>
import SliderFrame from "../sliderFiles/SliderFrame";
import SliderSlide from "../sliderFiles/SliderSlide.vue";
import SliderSlides from "../sliderFiles/SliderSlides.vue";
import vue2Dropzone from "vue2-dropzone";
import AddInterests from "@/components/profile/AddInterests";
import Interest from "@/components/profile/Interest";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import firebase from "@/firebase";
import db from "@/db";
import { mapState } from "vuex";

export default {
  components: {
    vueDropzone: vue2Dropzone,
    SliderFrame,
    SliderSlide,
    SliderSlides,
    AddInterests,
    Interest,
  },

  data: () => ({
    referralFeedback: "",
    yearMajorFeedback: "",
    photoFeedback: "",
    interestFeedback: "",
    userId: "",
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      maxFilesize: 5,
      maxFiles: 10,
      duplicateCheck: true,
      addRemoveLinks: true,
      dictDefaultMessage: "Edit Image",
      previewsContainer: false,
    },
    progressBar: {
      interests: false,
      bio: false,
      photos: false,
      joinGroup: false,
      addFriend: false,
      profileImage: false,
    },
    referralCode: null,
    Year: null,
    Major: null,
    profileImage: null,
    interests: [],
    loggedIn: false,
    schoolId: "",
  }),

  created() {
    this.$store.commit("profile/setInterests", []);
  },

  mounted() {
    if (firebase.auth().currentUser.uid) {
      this.userId = firebase.auth().currentUser.uid;
      this.loggedIn = true;
    }
    //this.getIOS();
    this.getSchool();
    if (this.referral !== "") {
      this.referralCode = this.referral;
    }

    //this.loggedIn = firebase.user().currentUser != null;
  },

  computed: {
    ...mapState("profile", ["newInterests", "isEditingInterest"]),
    ...mapState("user", ["referral"]),
  },

  methods: {
    getDeviceType() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return true;
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return true;
      }
      return false;
    },

    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
    //check if ios device

    getIOS() {
      if (this.iOS()) {
        window.location.replace("https://courselnk.page.link");
      }
    },
    backToLogin() {
      this.$router.push({ name: "Login" });
    },

    getSchool() {
      db.collection("users")
        .doc(firebase.auth().currentUser.uid)
        .get()
        .then((doc) => {
          this.schoolId = doc.data().school_id;
        });
    },

    goToProfile() {
      var id = firebase.auth().currentUser.uid;

      db.collection("users")
        .doc(id)
        .get()
        .then((doc) => {
          this.$store.commit("user/setUser", doc.data());
          this.$router.push({
            name: "Profile",
          });
        });
    },
    noReferralYet() {
      this.referralFeedback = "Please enter a referral code or skip this step";
    },
    addReferallCode(activeIndex, goToIndex) {
      if (this.referralCode.length < 3) {
        this.referralFeedback =
          "Please enter a referral code or skip this step";
        return;
      }
      db.collection("ambassadorInfo")
        .where("referralCode", "==", this.referralCode)
        .get()
        .then((query) => {
          if (!query.empty) {
            this.alreadyEntered = true;
            query.forEach((doc) => {
              var referralList = doc.data().referralIds;
              referralList.push(firebase.auth().currentUser.uid);
              console.log(referralList);
              db.collection("ambassadorInfo")
                .doc(doc.id)
                .update({
                  referralIds: referralList,
                });

              db.collection("users")
                .doc(firebase.auth().currentUser.uid)
                .update({
                  numReferrals: firebase.firestore.FieldValue.increment(1),
                });

              this.referralFeedback = "";
              goToIndex(activeIndex + 1);
            });
          } else {
            console.log(this.referralCode);
            firebase
              .auth()
              .fetchSignInMethodsForEmail(this.referralCode)
              .then((info) => {
                if (info.length > 0) {
                  if (!this.alreadyEntered) {
                    this.alreadyEntered = true;
                    var getUserFromEmail = firebase
                      .functions()
                      .httpsCallable("getUserFromEmail");
                    getUserFromEmail(this.referralCode).then((data) => {
                      db.collection("users")
                        .doc(data.data.uid)
                        .update({
                          numReferrals: firebase.firestore.FieldValue.increment(
                            1
                          ),
                        });
                      db.collection("users")
                        .doc(firebase.auth().currentUser.uid)
                        .update({
                          numReferrals: firebase.firestore.FieldValue.increment(
                            1
                          ),
                        });
                    });
                  }
                  this.referralFeedback = "";
                  goToIndex(activeIndex + 1);
                } else {
                  this.referralFeedback = "Please enter a valid referral code";
                }
              })
              .catch((error) => {
                console.log(error);
                this.referralFeedback = "Please enter a valid referral code";
              });
          }
        });
    },

    setInterests(activeIndex, goToIndex) {
      if (this.newInterests.length > 0) {
        this.progressBar.interests = true;
        this.interestFeedback = "";
        goToIndex(activeIndex + 1);
        db.collection("users")
          .doc(this.userId)
          .update({
            interests: this.newInterests,
            progressBar: this.progressBar,
          });
      } else {
        this.interestFeedback =
          "Please pick at least one interest or skip this step";
      }
    },

    addYearAndMajor(activeIndex, goToIndex) {
      if (
        this.Year != "1st Year" &&
        this.Year != "2nd Year" &&
        this.Year != "3rd Year" &&
        this.Year != "4th Year" &&
        this.Year != "5th Year" &&
        this.Year != "Grad" &&
        this.Year != "PhD"
      ) {
        this.yearMajorFeedback = "Please enter a given year";
      } else {
        /*  UPLOAD TO DB HERE */
        this.yearMajorFeedback = "";

        db.collection("users")
          .doc(this.userId)
          .update({
            year: this.Year,
            major: this.Major,
          });

        goToIndex(activeIndex + 1);
      }
    },

    addImage(activeIndex, goToIndex) {
      if (this.profileImage) {
        this.progressBar.profileImage = true;
        this.photoFeedback = "";
        goToIndex(activeIndex + 1);
        console.log(this.schoolId);
        db.collection("schools")
          .doc(this.schoolId)
          .get()
          .then((doc) => {
            var profileImageCount = doc.data().profileImageCount;

            db.collection("users")
              .doc(this.userId)
              .update({
                profileImage: this.profileImage,
                progressBar: this.progressBar,
                profileImageNumber: profileImageCount,
              });

            db.collection("schools")
              .doc(this.schoolId)
              .update({
                profileImageCount: firebase.firestore.FieldValue.increment(1),
              });
          });
      } else {
        this.photoFeedback = "Please upload a profile image or skip this step";
      }
    },

    async setImage(img) {
      const storageRef = firebase.storage().ref();

      var fileRef = storageRef.child(
        `profileImages/${img.name}${Date.now()}.png`
      );

      await fileRef.put(img);
      this.profileImage = await fileRef.getDownloadURL();
    },

    addInterests() {
      this.$store.commit("profile/setIsEditingInterest", true);
      this.interestFeedback = "";
      //goToIndex(activeIndex + 1);
    },
    cancelPreview(event) {
      if (event.target.className == "previewContainer") {
        this.$store.commit("profile/setIsEditingInterest", false);
        this.$store.commit("profile/setInterests", []);
      }
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
